import { useEffect, useState } from "react";
import {
  getFieldValuesByTableAndId,
  getTextByValueAndKey,
} from "../../../api/keyvalue";
import { validateOther } from "../../validations/validateRequestCreation";
import Grid from "../../Grid";
import ButtonRenderer from "../../renderer/ButtonRenderer";
import { useDispatch, useSelector } from "react-redux";
import { requestActions } from "../../../store/request-slice";
import Dropdown from "../../input/Dropdown";
import Input from "../../input/Input";
import Button from "../../input/Button";
import { ResizableScrollingTextRenderer } from "../../renderer/StyleRenderer";
import { AUTH_TYPES, FORMS, MODULES } from "../../../const";
import { toast } from "react-toastify";
import { hasMultiple } from "../../../common/logic";
import { isNumber } from "../../../helper";
import { chargesByCustomer } from "../../../api/customerChargesApi";
import { validateQuickRequestOther } from "../../validations/ValidateQuickRequestCreation";
import DeleteButtonRenderer from "../../renderer/DeleteButtonRenderer";

const FORM = FORMS.QUICK_REQUEST.OTHER.form;

const QuickRequestOtherInfo = ({ dropdown, editMode, isLoading }) => {
  const [requestOther, setRequestOther] = useState({
    rotChargeType: null,
    rotChargeTypeValue: "",
    rotValue: "",
    rotRemarks: "",
    rotStatus: 2,
    rotStatusValue: "",
    rotActive: 1,
    rotActiveValue: "",
  });

  const [filteredList, setFilteredList] = useState([]);
  const items = useSelector((state) => state.request.requestOtherRequests);
  const viewOnlyMode = useSelector((state) => state.request.viewOnlyMode);

  useEffect(() => {
    const filItems = items.filter((item) => {
      if (item === null) {
        return false;
      }
      return item.rotActive === 1;
    });
    setFilteredList(filItems);
  }, [items]);

  const customerId = useSelector((state) => state.request.reqLCustomerId);

  const dispatch = useDispatch();
  const [isAddLoading, setIsAddLoading] = useState(false);
  const [buttonClicked, setButtonClicked] = useState(false);
  const [errors, setErrors] = useState("");
  const [count, setCount] = useState(2);
  const [currentItem, setCurrentItem] = useState({});
  const [chargeTypeOptions, setChargeTypeOptions] = useState([]);

  const editModeOtherCount = useSelector(
    (state) => state.request.editModeOtherCount,
  );

  useEffect(() => {
    if (editMode) {
      setCount(editModeOtherCount);
    }
  }, [editModeOtherCount, editMode]);

  useEffect(() => {
    if (Object.keys(currentItem).length > 0) {
      setRequestOther({
        ...currentItem,
      });
    }
  }, [editMode, currentItem]);

  useEffect(() => {
    if (buttonClicked) {
      setRequestOther({
        rotChargeType: null,
        rotChargeTypeValue: "",
        rotValue: "",
        rotRemarks: "",
        rotStatus: 2,
        rotStatusValue: "",
        rotActive: 1,
        rotActiveValue: "",
      });
      setCurrentItem({});
      setErrors({});
      setButtonClicked(false);
    }
  }, [buttonClicked]);

  useEffect(() => {
    (async () => {
      if (customerId) {
        const data = await chargesByCustomer(customerId);
        setChargeTypeOptions(data);
      } else {
        setChargeTypeOptions([]);
      }
    })();
  }, [customerId]);

  const onAddClick = async () => {
    setIsAddLoading(true);
    const requestOtherErrors = validateQuickRequestOther(requestOther);
    if (Object.keys(requestOtherErrors).length === 0) {
      const nonUniqueRecord = hasMultiple({
        data: filteredList,
        newItem: requestOther,
        validator: (item) => item.rotChargeType === requestOther.rotChargeType,
        persistentIdentifier: "rotId",
      });
      if (nonUniqueRecord) {
        toast.warn("Cannot add multiple records with same charge type", {
          autoClose: 5000,
          containerId: "Main",
        });
        setIsAddLoading(false);
        return;
      }
      const rotChargeTypeValue = await getFieldValuesByTableAndId({
        tableName: "masterdata.tms_vm_stakeholder_charge_types",
        primaryKey: "chp_id",
        fieldNames: "cht_charge",
        ids: requestOther.rotChargeType,
      });
      const rotChargeName = rotChargeTypeValue[0]?.field1 || "";

      // const rotChargeTypeValue = await getTextByValueAndKey(
      //   "chg_type",
      //   requestOther.rotChargeType
      // );

      const rotStatusValue = await getTextByValueAndKey(
        "status",
        requestOther.rotStatus,
      );
      const rotActiveValue = await getTextByValueAndKey(
        "active",
        requestOther.rotActive,
      );

      if (!requestOther.rotId) {
        if (!requestOther.id) {
          dispatch(
            requestActions.addOther({
              ...requestOther,
              //rotValue: parseFloat(requestOther.rotValue),
              rotChargeTypeValue,
              //rotActiveValue,
              //rotStatusValue,
              rotChargeName,
              id: count,
            }),
          );
          setCount((prevState) => prevState + 1);
        } else {
          dispatch(
            requestActions.updateNonPersistedOther({
              other: {
                ...requestOther,
                //rotValue: parseFloat(requestOther.rotValue),
                rotChargeTypeValue,
                //rotActiveValue,
                //rotStatusValue,
              },
              id: parseInt(requestOther.id),
            }),
          );
        }
      } else {
        dispatch(
          requestActions.updatePersistedOther({
            other: {
              ...requestOther,
              //rotValue: parseFloat(requestOther.rotValue),
              rotChargeTypeValue,
              //rotActiveValue,
              //rotStatusValue,
              modified: true,
            },
            rotId: parseInt(requestOther.rotId),
          }),
        );
      }
      setButtonClicked(true);
    } else {
      setErrors(requestOtherErrors);
      document.querySelector(".ui.form").classList.add("error");
    }
    setIsAddLoading(false);
  };

  return (
    <div>
      <form className="ui form">
        <div className="ui segment">
          <div className="two fields">
            <Dropdown
              readOnly={viewOnlyMode}
              required={true}
              label="Charge Type"
              error={errors.rotChargeType}
              form={FORM}
              module={MODULES.Transaction}
              field="rot_charge_type"
              resetError={() =>
                setErrors((prevState) => {
                  const { rotChargeType: _, ...rest } = prevState;
                  return rest;
                })
              }
              name="charge_type"
              style={{ height: "20px" }}
              options={chargeTypeOptions}
              value={requestOther.rotChargeType}
              onChange={(e, data) =>
                setRequestOther((prevState) => ({
                  ...prevState,
                  rotChargeType: data.value,
                }))
              }
            />
            <Input
              readOnly={viewOnlyMode}
              label="Remark"
              error={errors.rotRemarks}
              form={FORM}
              module={MODULES.Transaction}
              field="rot_remarks"
              resetError={() =>
                setErrors((prevState) => {
                  const { rotRemarks: _, ...rest } = prevState;
                  return rest;
                })
              }
              name="qty"
              placeholder="Remark"
              value={requestOther.rotRemarks}
              onChange={(e) =>
                setRequestOther((prevState) => ({
                  ...prevState,
                  rotRemarks: e.target.value,
                }))
              }
            />
            <div
              style={{
                display: "flex",
                alignItems: "center",
                width: "100%",
                justifyContent: "flex-end",
              }}
            >
              <Button
                template="reset"
                onClick={(e) => {
                  setButtonClicked(true);
                }}
              />
              <Button
                template="addOrSave"
                authenticated={true}
                editMode={editMode}
                module={MODULES.Transaction}
                form={`${FORM}`}
                disabled={viewOnlyMode}
                create={Object.keys(currentItem).length === 0}
                onClick={onAddClick}
                isLoading={isAddLoading}
              />
            </div>
          </div>
          <div
            style={{
              width: "100%",
            }}
          >
            <Grid
              heading="Other Information List"
              searchable={false}
              pagination={false}
              config={[
                {
                  headerName: "Charge Type",
                  field: "rotChargeName",
                  cellRenderer: ResizableScrollingTextRenderer,
                },

                {
                  headerName: "Remark",
                  field: "rotRemarks",
                },

                {
                  field: "Edit",
                  filter: true,
                  cellRenderer: ButtonRenderer,
                  cellRendererParams: (params) => ({
                    consider: AUTH_TYPES.CREATE,
                    clickHandler: () => {
                      setCurrentItem(params.data);
                    },
                    label: viewOnlyMode ? "View" : "Edit",
                    authenticated: true,
                    form: `${FORM}`,
                    module: MODULES.Transaction,
                    editMode: editMode,
                  }),
                },
                {
                  field: "Delete",
                  filter: true,
                  cellRenderer: DeleteButtonRenderer,
                  cellRendererParams: (params) => ({
                    consider: AUTH_TYPES.DELETE,
                    clickHandler: () => {
                      if (params.data.rotId) {
                        dispatch(
                          requestActions.removeOther({
                            rotId: params.data.rotId,
                          }),
                        );
                      } else {
                        dispatch(
                          requestActions.removeNonPersistedOther({
                            id: params.data.id,
                          }),
                        );
                      }
                    },
                    label: "Delete",
                    className: "ui red button",
                    disabled: viewOnlyMode,
                    authenticated: true,
                    form: `${FORM}`,
                    module: MODULES.Transaction,
                    editMode:
                      params.data.rotId !== null && isNumber(params.data.rotId),
                  }),
                },
              ]}
              content={filteredList}
            />
          </div>
        </div>
      </form>
    </div>
  );
};

export default QuickRequestOtherInfo;
